import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import moment from "moment-timezone";
import { getSubcategories } from "../redux/actions/categoryActions.js";
import BannersComponent from './components/homeNewComponents/BannersComponent/BannersComponent';
import AboutNewComponent from './components/homeNewComponents/AboutNewComponent/AboutNewComponent';
import NewBlocksComponent from './components/homeNewComponents/BlocksComponent/NewBlocksComponent';
import NewMineralsComponent from './components/homeNewComponents/NewMineralsComponent/NewMineralsComponent';
import NewStockComponent from "./components/homeNewComponents/NewStockComponent/NewStockComponent.js";
import NewMainComponent from './components/homeNewComponents/NewMainComponent/NewMainComponent.js';
import NewRequestFormComponent from "./components/NewRequestComponent/newRequestFormComponent.js";
import AcknowledgementOfCountryComponent from "./components/AcknowledgementOfCountryComponent.js";
import styles from "./homeStyles.module.css";

const HomePageForVisitorNew = () => {
  const [perthTime, setPerthTime] = useState("");
  const [banners, setBanners] = useState();
  const [mobileBanners, setMobileBanners] = useState();
  const [blocks, setBlocks] = useState([]);
  const [error, setError] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSubcategories());
  }, []);

  useEffect(() => {
    setPerthTime(moment().tz("Australia/Perth").format("YYYY-MM-DD HH:mm:ss"));
  }, []);

  const getBanners = async (perthTime) => {
    const { data } = await axios.get(`/api/promotion/promotion/${perthTime}`);
    return data;
  };

  useEffect(() => {
    if (perthTime) {
      getBanners(perthTime)
        .then((data) => {
          const banners = data.filter((item) => item.category === "banners");
          const blocks = data.filter((item) => item.category === "blocks");
          const mobileBanners = data.filter((item) => item.category === "mobile-banners");
          setBanners(banners[0]);
          setBlocks(blocks[0]);
          setMobileBanners(mobileBanners[0]);
        })
        .catch((er) =>
          setError(
            er.response.data.message
              ? er.response.data.message
              : er.response.data
          )
        );
    }
  }, [perthTime]);

  return (<>
    <NewMainComponent />
    <div className={styles.promotionNew}>
      {/* <NewMineralsComponent sortedMineralPrice={sortedMineralPrice} /> */}
      <BannersComponent banners={banners} mobileBanners={mobileBanners} />
      {/* <NewStockComponent top50Companies={top50Companies} /> */}
    </div>
    <NewBlocksComponent blocks={blocks} />
    <AboutNewComponent />
    <div className={styles.image_cont} id="content"></div>
    <NewRequestFormComponent />
    {/* <AcknowledgementOfCountryComponent /> */}
  </>)
}

export default HomePageForVisitorNew;
